import { useEffect } from 'react';
import HomeServicesCarousel from './HomeServicesCarousel';
import '../pages/home/home.css';

const HomeServices = () => {

    return (
        <div className="home_services">
            <div className="container home_services_container">
                <div className="home_services_header">
                    <h3>WHAT WE OFFER</h3>
                    <h2>Get rid of unwanted pests!</h2>
                    <p>We are committed to providing you with safe, reliable, and effective pest control services to protect your property.</p>
                </div>
                <div className="home_services_carousel">
                    <div className="home_services_carousel_item">
                        <HomeServicesCarousel />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeServices